import React from 'react';
import { string, number, object } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { numberFormat } from '@fiverr-private/localization';
import WithImpressions from '../../../WithImpressions';
import {
    buildSellerCardAboutMeSkillTestsEvent,
    buildSellerCardAboutMeSkillTestsScoreEvent,
    buildSellerCardAboutMeSkillTestsScoreLabelEvent
} from './biData';

const Test = ({
    title = '',
    score = 0,
    status = '',
    biData = {}
}) => {

    const scoreFragment = score / 10;
    const statusClassname = `status ${status}`;
    const scoreFormatted = numberFormat(scoreFragment, {
        fallbackValue: scoreFragment
    });

    return (
        <li>
            <WithImpressions value={buildSellerCardAboutMeSkillTestsEvent(biData, title)}
                element="span">{title}</WithImpressions>

            <WithImpressions value={buildSellerCardAboutMeSkillTestsScoreEvent(biData, scoreFormatted)}
                element="strong">{scoreFormatted}<small>/10</small></WithImpressions>

            <WithImpressions value={buildSellerCardAboutMeSkillTestsScoreLabelEvent(biData, status)}
                element="span" className={statusClassname}>
                <I18n k={`user_page_perseus.seller_profile.skill_status.${status}`}/>
            </WithImpressions>
        </li>
    );
};

Test.propTypes = {
    title: string,
    score: number,
    status: string,
    biData: object
};

export default Test;
